import React, { useState } from "react";

import ProgressBar from "../common/ProgressBar";

import t, { tr } from "../../../../Common/utils/translation/translator";

// MSC-1778: Component ComparatorLine must be commonalized
import ComparatorLine from "../../../../Retrofit/components/Devices/BundleComparator/ComparatorLine";

const AxisComparatorCarriageSection = ({ carriageNumber, compareDatas, ...props }) => {
  const [showCarriage, setCarriage] = useState(false);

  return (
    <div className="AxisComparatorCarriageSection" {...props}>
      <ComparatorLine
        data-testid={`axis-comparator-carriage-comparator-section-${carriageNumber + 1}`}
        compareData={compareDatas}
        title={tr("cartesian.ui.axis_selection.carriage_n", { n: carriageNumber + 1 })}
        isSectionHeader
        opened={showCarriage}
        values={compareDatas.map((bundle) => (
          <div>{bundle.carriageType?.typeOfCarriage}</div>
        ))}
        onClick={() => {
          setCarriage(!showCarriage);
        }}
      />
      {showCarriage && (
        <>
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumForceFys-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.force_fy")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.forceFys[carriageNumber]}
                data-testid="progress-bar-maximumForceFys"
                reference={Math.round(bundle.calculations?.forcesTorques_mecha_Force_Fymax)}
                unit="Nm"
              />
            ))}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumForceFzs-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.force_fz")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.forceFzs[carriageNumber]}
                data-testid="progress-bar-maximumForceFzs"
                reference={Math.round(bundle.calculations?.forcesTorques_mecha_Force_Fzmax)}
                unit="Nm"
              />
            ))}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumTorqueMxs-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.torque_fx")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.torqueMxs[carriageNumber]}
                data-testid="progress-bar-maximumTorqueMxs"
                reference={Math.round(bundle.calculations?.forcesTorques_mecha_Tourque_Mxmax)}
                unit="Nm"
              />
            ))}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumTorqueMys-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.torque_fy")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.torqueMys[carriageNumber]}
                data-testid="progress-bar-maximumTorqueMys"
                reference={Math.round(bundle.calculations?.forcesTorques_mecha_Tourque_Mymax)}
                unit="Nm"
              />
            ))}
          />
          <ComparatorLine
            data-testid={`axis-comparator-carriage-comparator-line-maximumTorqueMzs-${carriageNumber + 1}`}
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.torque_fz")}
            values={compareDatas.map((bundle) => (
              <ProgressBar
                percentage={bundle.calculations?.torqueMzs[carriageNumber]}
                data-testid="progress-bar-maximumTorqueMzs"
                reference={Math.round(bundle.calculations?.forcesTorques_mecha_Tourque_Mzmax)}
                unit="Nm"
              />
            ))}
          />
        </>
      )}
    </div>
  );
};

export default AxisComparatorCarriageSection;
